import reports from '../api/reports'
import timestamp from 'unix-timestamp';
import affiliates from '@/api/affiliates';
import chartResponse from '../helpers/chartResponse';
timestamp.round = true
export default {
  state: {
    reports: [],
    drillDownReports: {},
    chartReport: {},
    fromDate: timestamp.now(),
    toDate: timestamp.now(),
    filters: {},
    filtersData: {},
    onlyAggregatedStats: false,
    exportCounter: 0,
    reportsWithoutPagination: {},
    exportFinished: false,
    exportData: {},
    exportFields: [],
    breakdownBy: null,
  },
  namespaced: true,
  mutations: {
    async saveOffersReportsStore(state, data) {
      state.reports[data.entity] = data.statuses
    },
    async saveCampaignsReportsStore(state, data) {
      state.reports[data.entity] = data.statuses
    },
    async saveDrillDownReportsStore(state, data) {
      // state.drillDownReports = data.statuses
      state.drillDownReports[data.drillDownId] = data.statuses
    },
    async saveDrillDownReportsWithoutPaginationStore(state, data) {
      // state.drillDownReports = data.statuses
      state.drillDownReports[data.drillDownId] = data.statuses;
      state.reportsWithoutPagination = data.statuses || {};
    },
    setExportFinished(state, status) {
      state.exportFinished = status;
    },
    async saveChartReportStore(state, data) {
      return state.chartReport[data.drillDownId] = data;
    },
    async saveReportMainFilterStore(state, data) {
      const drillDownProperty = `${data.entity}-${data.drillDownId}`
      state.filters[drillDownProperty] = data.data
    },
    updateDate (state, payload) {
      let todayDate = new Date()
      let todayDateUnix = timestamp.now()
      let oneDayUnix = 86400
      switch (payload.typeDate) {
        case 'Today':
          state.fromDate = todayDateUnix
          state.toDate = todayDateUnix
          break;
        case 'Yesterday':
          state.fromDate = todayDateUnix  - oneDayUnix
          state.toDate = todayDateUnix
          break;
        case 'Week to date':
          state.fromDate = todayDateUnix - (oneDayUnix * 7)
          state.toDate = todayDateUnix
          break;
        case 'Month to date':
          state.fromDate = todayDateUnix - (oneDayUnix * 30)
          state.toDate = todayDateUnix
          break;
        case 'Year to day':
          state.fromDate = todayDateUnix - (oneDayUnix * 365)
          state.toDate = todayDateUnix
          break;
        case 'fromDateCustom':
          state.fromDate = timestamp.fromDate(payload.date)
          break;
        case 'toDateCustom':
          state.toDate = timestamp.fromDate(payload.date)
          break;
        case 'Custom':
          state.fromDate = timestamp.fromDate(payload.fromDate)
          state.toDate = timestamp.fromDate(payload.toDate)
          break;
        case 'Last week':
          let firstDayOfTheWeek = todayDate.getDate() - todayDate.getDay()
          let lastDayOfTheWeek = firstDayOfTheWeek + 6
          let firstDayOfLastWeek = new Date(todayDate.setDate(firstDayOfTheWeek - 7))
          let lastDayOfLastWeek = new Date(todayDate.setDate(lastDayOfTheWeek - 7))
          state.fromDate = timestamp.fromDate(firstDayOfLastWeek)
          state.toDate = timestamp.fromDate(lastDayOfLastWeek)
          break;
        case 'Last month':
          let year = todayDate.getFullYear()
          let month = String(todayDate.getMonth()).length === 1 ? '0' + todayDate.getMonth() : todayDate.getMonth()
          let fromDay = '01'
          let toDay = '31'
          let fromLastMonthDate =  year + '-' + month  + '-' + fromDay
          let toLastMonthDate =  year + '-' + month + '-' + toDay

            if(todayDate.getMonth() === 0){
              month = '12'
              year = todayDate.getFullYear() - 1
            }

            if(month === '04' || '06' || '09' || '11'){
              toDay = '30'
            }else if (month === '02') {
              toDay = '28'
            }

          state.fromDate = timestamp.fromDate(fromLastMonthDate)
          state.toDate = timestamp.fromDate(toLastMonthDate)
          break;

      }
      console.log(payload.typeDate)
    },
    async setFilterData(state, {key, data}) {
      const filterData = {};
      filterData[key] = data;
      console.log(filterData);
      state.filtersData = Object.assign({}, state.filtersData , filterData);
    },
    async saveOnlyAggregatedStats(state, data) {
      state.onlyAggregatedStats = data.onlyAggregatedStats
    },
    exportReportStore(state, data) {
      state.exportCounter += 1;
    },
    setExportReportDataStore(state, data) {
      state.exportData = data;
    },
    setExportFieldsStore(state, data) {
      state.exportFields = data;
    },
    setBreakdownByStore(state, data) {
      state.breakdownBy = data;
    }
  },
  actions: {
    async saveOffersReports({commit}, data) {
      commit('saveOffersReportsStore', await reports.getOffersReports(data))
    },
    async saveCampaignsReports({commit}, data) {
      commit('saveCampaignsReportsStore', await reports.getCampaignsReports(data))
    },
    async saveDrillDownReports({commit, dispatch}, data) {
      try {
        commit('saveDrillDownReportsStore', await reports.getDrillDownReports(data))
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveDrillDownReportsWithoutPagination({commit, dispatch}, data) {
      try {
        commit('saveDrillDownReportsWithoutPaginationStore', await reports.getDrillDownReports(data));
        commit('setExportFinished', true)
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveChartReport({commit, dispatch}, data) {
      try {
        commit('saveChartReportStore', await reports.getChartReports(data))
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveMainFilterData({commit, dispatch}, data) {
      try {
        commit('saveReportMainFilterStore', await reports.getMainFilterData(data))
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async getFilterData({commit, dispatch}, data) {
      try {
        commit('setFilterData', {key: data.name, data: await reports.getFilter(data)}) // await affiliates.getFilter(data)
      } catch (err) {
        dispatch('alert/ALERT_ERROR', err.message, {root: true});
      }
    },
    async saveOnlyAggregatedStats({dispatch, commit}, data) {
      commit('saveOnlyAggregatedStats', data)
    },
    exportReport({dispatch, commit}, data) {
      commit('setExportFinished', data);
      commit('exportReportStore');
    },
    setExportReportData({dispatch, commit}, data) {
      commit('setExportReportDataStore', data);
    },
    setExportFields({commit}, data) {
      commit('setExportFieldsStore', data);
    },
    setBreakdownBy({commit}, data) {
      commit('setBreakdownByStore', data);
    },
  },
  getters: {
    getReports: state => state.reports,
    getChartReport: state => state.chartReport,
    getDrillDownReports: state => state.drillDownReports,
    getMainFilterData: state => state.filters,
    filtersData: state => state.filtersData,
    onlyAggregatedStats: state => state.onlyAggregatedStats,
    getExportCounter: state => state.exportCounter,
    getReportStatus: state => state.exportFinished,
    getExportData: state => state.exportData,
    getExportFields: state => state.exportFields,
    getBreakdownBy: state => state.breakdownBy,
    getReportsWithoutPagination: state => state.reportsWithoutPagination
  }
}
